var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',[_c('h3',[_vm._v("Quests")]),_c('p',[_vm._v("Under construction :(")])])}
var staticRenderFns = []

export { render, staticRenderFns }